import { render, staticRenderFns } from "./SearchFilterChip.vue?vue&type=template&id=eb3d4ad8&scoped=true"
import script from "./SearchFilterChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchFilterChip.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3d4ad8",
  null
  
)

export default component.exports